var _path, _g, _path2, _path3, _path4, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRiskIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 111,
    height: 106,
    viewBox: "0 0 111 106",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M110.624 100.215L94.7272 51.5017L78.8438 2.78887C78.6553 2.20003 78.3337 1.6625 77.904 1.21792C77.4891 0.806625 76.9898 0.490497 76.4405 0.291463C76.3536 0.256659 76.2637 0.229698 76.172 0.210901L-nan -nanL76.172 0.210901C75.5357 0.0707044 74.8861 -1.52588e-05 74.2346 -1.52588e-05H72.2579L71.5186 0.291463L73.0571 0.573428C72.6933 0.78232 72.3667 1.05 72.0904 1.36562L37.8532 39.4712L3.61597 77.5902C3.14216 78.1058 2.81506 78.7389 2.66867 79.4236C2.52228 80.1084 2.56194 80.8198 2.78353 81.4841C3.00125 82.1514 3.3896 82.7503 3.91007 83.2213C4.43054 83.6924 5.17448 83.9327 5.86017 84.0829L55.8848 94.6962L103.795 104.88C103.985 104.92 101.973 104.919 102.135 104.953C102.696 105.072 103.133 105.165 103.795 105.306C104.477 105.438 107.365 105.429 108.024 105.209C108.682 104.988 109.273 104.601 109.737 104.085C110.202 103.568 110.526 102.941 110.676 102.263C110.827 101.585 110.8 100.879 110.597 100.215H110.624Z",
    fill: "url(#paint0_linear_510_3071)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_510_3071)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M69.4722 1.26593L35.2216 39.3581L0.984365 77.4771C0.528739 78.0027 0.216993 78.6374 0.0794868 79.3193C-0.0580199 80.0012 -0.0166002 80.7071 0.199712 81.3682C0.416024 82.0294 0.799856 82.6232 1.31383 83.0919C1.8278 83.5606 2.45439 83.8883 3.13258 84.0429L53.2532 94.6367L103.347 105.231C104.028 105.36 104.731 105.311 105.387 105.089C106.044 104.868 106.632 104.48 107.095 103.964C107.559 103.449 107.881 102.822 108.031 102.145C108.181 101.469 108.154 100.765 107.952 100.101L92.109 51.3886L76.2257 2.67575C75.9946 2.02752 75.6014 1.44928 75.0834 0.996201C74.5655 0.543119 73.9401 0.230299 73.2669 0.0875779C72.5937 -0.0551436 71.8952 -0.0230071 71.2379 0.180922C70.5807 0.384852 69.9867 0.753773 69.5125 1.2525L69.4722 1.26593Z",
    fill: "url(#paint1_linear_510_3071)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M70.2915 4.51525L37.1418 41.4124L3.99212 78.2962C3.72415 78.594 3.53927 78.957 3.45605 79.3489C3.37283 79.7407 3.3942 80.1476 3.51801 80.5286C3.64183 80.9096 3.86373 81.2513 4.16142 81.5193C4.4591 81.7874 4.82209 81.9724 5.21391 82.0557L53.7368 92.3139L102.246 102.559C102.64 102.654 103.053 102.642 103.441 102.524C103.829 102.406 104.178 102.186 104.452 101.887C104.726 101.588 104.915 101.222 105 100.825C105.084 100.428 105.06 100.016 104.931 99.6316L89.5314 52.4762L74.1448 5.29401C74.0212 4.92112 73.8006 4.58783 73.5056 4.32829C73.2107 4.06876 72.8521 3.89231 72.4665 3.81705C72.0747 3.72926 71.6665 3.74769 71.2841 3.87043C70.9017 3.99317 70.559 4.21578 70.2915 4.51525Z",
    fill: "url(#paint2_linear_510_3071)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M70.7751 8.39562L39.344 43.3862L7.92629 78.3633C7.82762 78.468 7.75879 78.5973 7.72697 78.7376C7.69516 78.878 7.7015 79.0243 7.74536 79.1613C7.78921 79.2984 7.86897 79.4212 7.97635 79.5169C8.08372 79.6127 8.21479 79.678 8.35593 79.706L54.3546 89.4271L100.367 99.1482C100.505 99.174 100.649 99.1641 100.782 99.1195C100.916 99.0749 101.037 98.997 101.132 98.8931C101.23 98.7892 101.297 98.66 101.326 98.52C101.354 98.38 101.343 98.2348 101.293 98.1009L86.7122 53.4027L72.1311 8.69101C72.0903 8.5565 72.0138 8.43556 71.9098 8.341C71.8058 8.24644 71.6781 8.1818 71.5404 8.15393C71.4028 8.12241 71.2594 8.12819 71.1249 8.17068C70.9903 8.21317 70.8695 8.29083 70.7751 8.39562Z",
    fill: "url(#paint3_linear_510_3071)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M65.0144 24.4676C65.0144 24.4676 65.4574 25.4478 66.0885 26.6562C66.7112 27.8996 67.4627 29.0742 68.3307 30.1607C69.1184 31.0128 70.0224 31.7496 71.0159 32.3492C71.5274 32.6693 72.0564 32.9607 72.6003 33.222L65.2426 43.7218L57.8715 54.2217L66.2093 51.1201L74.5471 48.0185L68.4381 59.579L62.1277 71.153L64.625 72.1601L67.1357 73.1805L60.7582 77.7994L54.3941 82.4719L53.8839 74.9931L53.3603 67.5143L55.6965 68.4677L58.0192 69.4075L61.0402 63.5265L64.0611 57.659L54.8238 60.6398L45.6133 63.6608L55.3205 44.0709L65.0144 24.4676Z",
    fill: "url(#paint4_linear_510_3071)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_510_3071",
    x: 0,
    y: 0,
    width: 108.127,
    height: 105.301,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_510_3071"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_510_3071",
    x1: 56.6771,
    y1: -0.0000152588,
    x2: 56.6771,
    y2: 105.392,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4BA38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8F6E07"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_510_3071",
    x1: 54.0632,
    y1: 0,
    x2: 54.0632,
    y2: 105.301,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD85E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0BA15"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_510_3071",
    x1: 54.2278,
    y1: 3.7625,
    x2: 54.2278,
    y2: 102.622,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#525252"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D1D1D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_510_3071",
    x1: 54.5241,
    y1: 8.13391,
    x2: 54.5241,
    y2: 99.1622,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD85E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0BA15"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_510_3071",
    x1: 60.0802,
    y1: 24.4676,
    x2: 60.0802,
    y2: 82.4719,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#525252"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#232323"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRiskIcon);
export default __webpack_public_path__ + "static/media/RiskIcon.7e6f1780d9d9c0fdddb1aae2fa4f6464.svg";
export { ForwardRef as ReactComponent };